module.exports = __webpack_public_path__ + "img/RA-banner.b1dceac0.png";